import { deserialize, deserializeAs, inheritSerialization } from 'cerialize';
import { Entity } from './entity';
import { Role } from './roles.enum';
import { Societe } from './societe';
import { Adresse } from './adresse';

@inheritSerialization(Entity)
export class CorrespondantClient extends Entity {

  @deserializeAs('adresse_email')
  adresseEmail: string;

  @deserializeAs(Role, 'roles')
  roles: Role[];

  @deserialize
  nom: string;

  @deserialize
  prenom: string;

  @deserialize
  genre: string;

  @deserialize
  photo: string;

  @deserialize
  actif: boolean;

  @deserializeAs(Adresse, 'adresse')
  adresse: Adresse;

  @deserializeAs(Societe, 'societe')
  societe: Societe;

  @deserializeAs(Date, 'date_premiere_connexion')
  datePremiereConnexion: Date;

  @deserializeAs(Date, 'date_envoi_mail_premiere_connexion')
  dateEnvoiMailPremiereConnexion: Date;

  @deserializeAs(Date, 'date_derniere_connexion')
  dateDerniereConnexion: Date;

}
